import React from 'react';

import styles from './notificationsIndexStyles';

import NotificationsSidebar from './NotificationsSidebar/notificationsSidebar';
import NotificationsListContainer from 'buyside/components/container/Notifications/NotificationsListContainer';

class NotificationsIndex extends React.Component {
  constructor() {
    super();
    this.state = { openTab: 'all' };
    this.changeTab = this.changeTab.bind(this);
  }

  changeTab(tab) {
    return () => {
      if (this.state.openTab !== tab) {
        this.setState({ openTab: tab });
      }
    };
  }

  render() {
    const { openTab } = this.state;

    return (
      <div className={styles.notificationsList}>
        <NotificationsSidebar openTab={openTab} changeTab={this.changeTab} />
        <NotificationsListContainer openTab={openTab} />
      </div>
    );
  }
}

export default NotificationsIndex;
